import { groupDetailsActionTypes } from './Constants';

export function getGroupDetailsRequest(groupId) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_DETAILS_REQUEST,
		payload: {
			groupId,
		},
	};
}

export function getGroupDetailsSuccess(groupDetails) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_DETAILS_SUCCESS,
		payload: {
			groupDetails,
		},
	};
}

export function getGroupDetailsError() {
	return {
		type: groupDetailsActionTypes.GET_GROUP_DETAILS_ERROR,
	};
}

export function getGroupListsRequest(groupId) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_LISTS_REQUEST,
		payload: {
			groupId,
		},
	};
}

export function getGroupListsSuccess(lists) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_LISTS_SUCCESS,
		payload: {
			lists,
		},
	};
}

export function getGroupListsError(error) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_LISTS_ERROR,
		payload: {
			error,
		},
	};
}

export function toggleAddListModal(status) {
	return {
		type: groupDetailsActionTypes.TOGGLE_GROUP_ADD_LIST_MODAL,
		payload: {
			status,
		},
	};
}

export function addItemsRequest(id, practiceableItems) {
	return {
		type: groupDetailsActionTypes.GROUP_ADD_ITEMS_REQUEST,
		payload: {
			id,
			practiceableItems,
		},
	};
}

export function addItemsSuccess() {
	return {
		type: groupDetailsActionTypes.GROUP_ADD_ITEMS_SUCCESS,
		payload: {},
	};
}

export function addItemsError() {
	return {
		type: groupDetailsActionTypes.GROUP_ADD_ITEMS_ERROR,
	};
}

export function getGroupMembersRequest(groupId, range = 'all', type = '') {
	return {
		type: groupDetailsActionTypes.GET_GROUP_MEMBERS_REQUEST,
		payload: {
			groupId,
			range,
			type,
		},
	};
}

export function getGroupMembersSuccess(members, inactiveLicenses, expiredLicenses) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_MEMBERS_SUCCESS,
		payload: {
			members,
			inactiveLicenses,
			expiredLicenses,
		},
	};
}

export function getGroupMembersError(error) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_MEMBERS_ERROR,
		payload: {
			error,
		},
	};
}

export function cleanMembersState() {
	return {
		type: groupDetailsActionTypes.CLEAN_MEMBERS_STATE,
	};
}

export function deleteUserFromGroupRequest(groupId, groupUserId, callback) {
	return {
		type: groupDetailsActionTypes.DELETE_USER_FROM_GROUP_REQUEST,
		payload: {
			groupId,
			groupUserId,
			callback,
		},
	};
}

export function deleteUserFromGroupSuccess(groupUserId) {
	return {
		type: groupDetailsActionTypes.DELETE_USER_FROM_GROUP_SUCCESS,
		payload: {
			groupUserId,
		},
	};
}

export function deleteUserFromGroupError() {
	return {
		type: groupDetailsActionTypes.DELETE_USER_FROM_GROUP_ERROR,
	};
}

export function deleteListFromGroupRequest(data) {
	return {
		type: groupDetailsActionTypes.DELETE_LIST_FROM_GROUP_REQUEST,
		payload: {
			data,
		},
	};
}

export function deleteListFromGroupSuccess(data) {
	return {
		type: groupDetailsActionTypes.DELETE_LIST_FROM_GROUP_SUCCESS,
		payload: {
			data,
		},
	};
}

export function deleteListFromGroupError() {
	return {
		type: groupDetailsActionTypes.DELETE_LIST_FROM_GROUP_ERROR,
	};
}

export function acceptUserRequest(groupId, userId, firstName, lastName) {
	return {
		type: groupDetailsActionTypes.ACCEPT_USER_REQUEST,
		payload: {
			groupId,
			userId,
			firstName,
			lastName,
		},
	};
}

export function acceptUserSuccess(userId) {
	return {
		type: groupDetailsActionTypes.ACCEPT_USER_SUCCESS,
		payload: {
			userId,
		},
	};
}

export function acceptUserError() {
	return {
		type: groupDetailsActionTypes.ACCEPT_USER_ERROR,
	};
}

export function declineUserRequest(groupId, userId) {
	return {
		type: groupDetailsActionTypes.DECLINE_USER_REQUEST,
		payload: {
			groupId,
			userId,
		},
	};
}

export function declineUserSuccess(userId) {
	return {
		type: groupDetailsActionTypes.DECLINE_USER_SUCCESS,
		payload: {
			userId,
		},
	};
}

export function declineUserError() {
	return {
		type: groupDetailsActionTypes.DECLINE_USER_ERROR,
	};
}

export function revokeUserInviteRequest(groupId, groupUserId) {
	return {
		type: groupDetailsActionTypes.REVOKE_USER_INVITE_REQUEST,
		payload: {
			groupId,
			groupUserId,
		},
	};
}

export function revokeUserInviteSuccess(groupUserId) {
	return {
		type: groupDetailsActionTypes.REVOKE_USER_INVITE_SUCCESS,
		payload: {
			groupUserId,
		},
	};
}

export function revokeUserInviteError() {
	return {
		type: groupDetailsActionTypes.REVOKE_USER_INVITE_ERROR,
	};
}

export function checkIfUserExistRequest(data) {
	return {
		type: groupDetailsActionTypes.CHECK_IF_USER_EXIST_REQUEST,
		payload: data,
	};
}

export function checkIfUserExistSuccess() {
	return {
		type: groupDetailsActionTypes.CHECK_IF_USER_EXIST_SUCCESS,
	};
}

export function checkIfUserExistError(error, message, fieldIndex) {
	return {
		type: groupDetailsActionTypes.CHECK_IF_USER_EXIST_ERROR,
		error: true,
		payload: {
			error,
			message,
			fieldIndex,
		},
	};
}

export function setValidInviteMembers(status) {
	return {
		type: groupDetailsActionTypes.SET_VALID_INVITE_MEMBERS,
		payload: {
			status,
		},
	};
}

export function toggleGroupInviteModal(data, activeTabIndex = 0) {
	return {
		type: groupDetailsActionTypes.TOGGLE_GROUP_INVITE_MODAL,
		payload: {
			data,
			activeTabIndex,
		},
	};
}

export function inviteUsersRequest(groupId, emails, usernames, isOnMembersPage) {
	return {
		type: groupDetailsActionTypes.INVITE_USERS_REQUEST,
		payload: {
			groupId,
			emails,
			usernames,
			isOnMembersPage,
		},
	};
}

export function inviteUsersSuccess() {
	return {
		type: groupDetailsActionTypes.INVITE_USERS_SUCCESS,
	};
}

export function inviteUsersError() {
	return {
		type: groupDetailsActionTypes.INVITE_USERS_ERROR,
	};
}

export function clearInviteUsersForm() {
	return {
		type: groupDetailsActionTypes.CLEAR_INVITE_USERS_FORM,
	};
}

export function getGroupListMembersRequest(groupId, listId, type) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_LIST_MEMBERS_REQUEST,
		payload: {
			groupId,
			listId,
			type,
		},
	};
}

export function getGroupListMembersSuccess(members, listId, summary) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_LIST_MEMBERS_SUCCESS,
		payload: {
			members,
			listId,
			summary,
		},
	};
}

export function getGroupListMembersError(groupId, listId) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_LIST_MEMBERS_ERROR,
		error: true,
		payload: {
			groupId,
			listId,
		},
	};
}

export function getGroupListResultsRequest(groupId, userId, listId, range = 'all', type = 'list') {
	return {
		type: groupDetailsActionTypes.GET_GROUP_LIST_RESULTS_REQUEST,
		payload: {
			groupId,
			userId,
			listId,
			range,
			type,
		},
	};
}

export function getGroupListResultsSuccess(results, listId, userId) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_LIST_RESULTS_SUCCESS,
		payload: {
			results,
			listId,
			userId,
		},
	};
}

export function getGroupListResultsError(userId, listId) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_LIST_RESULTS_ERROR,
		error: true,
		payload: {
			userId,
			listId,
		},
	};
}

export function clearGroupDetails() {
	return {
		type: groupDetailsActionTypes.CLEAR_GROUP_DETAILS,
		payload: {},
	};
}

export function getGroupMemberListsRequest(groupId, userId, range = 'all') {
	return {
		type: groupDetailsActionTypes.GET_GROUP_MEMBER_LISTS_REQUEST,
		payload: {
			groupId,
			userId,
			range,
		},
	};
}

export function getGroupMemberListsSuccess(lists, userId, summary) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_MEMBER_LISTS_SUCCESS,
		payload: {
			lists,
			userId,
			summary,
		},
	};
}

export function getGroupMemberListsError(userId) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_MEMBER_LISTS_ERROR,
		error: true,
		payload: {
			userId,
		},
	};
}

export function cleanGroupContentState() {
	return {
		type: groupDetailsActionTypes.CLEAN_GROUP_CONTENT_STATE,
	};
}

export function getDifficultWordsRequest(groupId, listId, range = 'all') {
	return {
		type: groupDetailsActionTypes.GET_DIFFICULT_WORDS_REQUEST,
		payload: {
			groupId,
			listId,
			range,
		},
	};
}

export function getDifficultWordsSuccess(difficultWords, subject, listId) {
	return {
		type: groupDetailsActionTypes.GET_DIFFICULT_WORDS_SUCCESS,
		payload: {
			difficultWords,
			subject,
			listId,
		},
	};
}

export function getDifficultWordsError(listId) {
	return {
		type: groupDetailsActionTypes.GET_DIFFICULT_WORDS_ERROR,
		payload: {
			listId,
		},
	};
}

export function getGroupQuestions(groupId, listId, type) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_QUESTIONS,
		payload: {
			groupId,
			listId,
			type,
		},
	};
}

export function getGroupQuestionsSuccess(listId, data) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_QUESTIONS_SUCCESS,
		payload: {
			listId,
			data,
		},
	};
}

export function getGroupQuestionsError(listId) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_QUESTIONS_ERROR,
		payload: {
			listId,
		},
	};
}

export function getGroupQuestionAnswers(groupId, questionId, listId, type) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_QUESTION_ANSWERS,
		payload: {
			groupId,
			questionId,
			listId,
			type,
		},
	};
}

export function getGroupQuestionAnswersSuccess(questionId, data) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_QUESTION_ANSWERS_SUCCESS,
		payload: {
			questionId,
			data,
		},
	};
}

export function getGroupQuestionAnswersError(questionId) {
	return {
		type: groupDetailsActionTypes.GET_GROUP_QUESTION_ANSWERS_ERROR,
		payload: {
			questionId,
		},
	};
}

export function getInstituteLicences(instituteId, groupId) {
	return {
		type: groupDetailsActionTypes.GET_INSTITUTE_LICENCES,
		payload: { instituteId, groupId },
	};
}

export function getInstituteLicencesSuccess(data) {
	return {
		type: groupDetailsActionTypes.GET_INSTITUTE_LICENCES_SUCCESS,
		payload: { data },
	};
}

export function getInstituteLicencesError() {
	return {
		type: groupDetailsActionTypes.GET_INSTITUTE_LICENCES_ERROR,
	};
}

export function addLicencesToGroup(groupId, licenseIds) {
	return {
		type: groupDetailsActionTypes.ADD_LICENCES_TO_GROUP,
		payload: { groupId, licenseIds },
	};
}

export function addLicencesToGroupFinal() {
	return {
		type: groupDetailsActionTypes.ADD_LICENCES_TO_GROUP_FINAL,
	};
}

export function removeInactiveLicense(groupId, licenseId) {
	return {
		type: groupDetailsActionTypes.REMOVE_INACTIVE_LICENSE,
		payload: { groupId, licenseId },
	};
}

export function removeInactiveLicenseSuccess(licenseId) {
	return {
		type: groupDetailsActionTypes.REMOVE_INACTIVE_LICENSE_SUCCESS,
		payload: { licenseId },
	};
}

export function promoteGroupUserToManager(groupId, user, callback) {
	return {
		type: groupDetailsActionTypes.PROMOTE_GROUP_USER_TO_MANAGER,
		payload: { groupId, user, callback },
	};
}

export function promoteGroupUserToManagerFinal() {
	return {
		type: groupDetailsActionTypes.PROMOTE_GROUP_USER_TO_MANAGER_FINAL,
	};
}
